export default __webpack_public_path__ + "static/media/bootstrap.min.css.7b5d8282.map";